import React from "react";
import styled from "styled-components";

import { ButtonPrimaryLink, ButtonSecondaryLink } from "@components/Button";
import Layout from "@components/Layout";

import { Row } from "@styles/grid";

import BrandsTable from "./PartnersTable";
import { getAllPartners } from "@actions/partners.action";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem auto 5.5rem;
  max-width: 125rem;
  width: 100%;
  padding: 0 2.5rem;
`;

const Partners = () => {
  const { all: partners } = useSelector(({ partners }) => partners);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      if (!partners || !partners.length) {
        await dispatch(getAllPartners("iframe"));
      }
    })();
  }, [partners]);

  return (
    <Layout pageTitle="Partners">
      <Content>
        <Row justify="space-between" margin="2rem 0">
          <ButtonSecondaryLink outlined uppercase href="/">
            Back to Dashboard
          </ButtonSecondaryLink>
          <ButtonPrimaryLink uppercase href="/partners/add">
            Add partner
          </ButtonPrimaryLink>
        </Row>
        <BrandsTable />
      </Content>
    </Layout>
  );
};

export default Partners;
